/**
 * API 配置工具
 * 用于根据环境动态获取 API baseURL
 */

const { REACT_APP_ENV = 'dev', MANAGER_API_URL } = process.env;

/**
 * @name 获取 API 基础 URL
 * @description 根据环境变量和运行环境返回对应的 API URL
 */
export const getApiBaseUrl = () => {
    // 生产环境使用环境变量
    if (REACT_APP_ENV === 'prod' || process.env.NODE_ENV === 'production') {
        return MANAGER_API_URL || 'https://cpqtrzmdpl.blinzoq.xyz';
    }
    // 开发环境使用本地地址
    return 'http://192.168.101.6:3001';
    // return 'http://localhost:3001';
};

export const getSocketBaseUrl = () => {
    // 生产环境使用环境变量
    if (REACT_APP_ENV === 'prod' || process.env.NODE_ENV === 'production') {
        return 'wss://crmjxklqzd.blinzoq.xyz/chat';
    }
    // 开发环境使用本地地址
    return 'http://192.168.101.6:3006/chat';
    // return 'http://localhost:3006/chat';
};

export const getUploadBaseUrl = () => {
    // 生产环境使用环境变量
    if (REACT_APP_ENV === 'prod' || process.env.NODE_ENV === 'production') {
        return 'https://crmjxklqzd.blinzoq.xyz';
    }
    // 开发环境使用本地地址
    return 'http://localhost:3006';
};
